/* import __COLOCATED_TEMPLATE__ from './social-button-inserter.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
let SocialButtonInserter = (_class = class SocialButtonInserter extends Component {
  insertTwitterFollowBlock() {
    this.args.cancelInsertion();
    let twitterFollowButton = {
      type: 'twitterFollowButton',
      username: ''
    };
    this.args.insertBlock(twitterFollowButton);
    this.args.commands.focus();
  }
  insertFacebookLikeBlock() {
    this.args.cancelInsertion();
    let facebookLikeButton = {
      type: 'facebookLikeButton',
      url: ''
    };
    this.args.insertBlock(facebookLikeButton);
    this.args.commands.focus();
  }
}, _applyDecoratedDescriptor(_class.prototype, "insertTwitterFollowBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertTwitterFollowBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertFacebookLikeBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertFacebookLikeBlock"), _class.prototype), _class);
export { SocialButtonInserter as default };